export const setObjRegionEdit = (state, payload) => {	
	state.objRegionEdit = ''; 	
	payload.parent = parseInt( payload.parent );  
	state.objRegionEdit = payload;	
}

export const emptyRegionEdit = (state, payload) => {
	state.objRegionEdit = []
}

export const setRegionList = (state, payload) => {			

	//console.log( payload );	
	/*for( var c in payload.Country) {
		payload.Country[c].children = [];
		if(payload.Province.length > 0) {
			for( var p in payload.Province ) {
				if( payload.Province[p].parent == payload.Country[c].loc_id ) {
					var province = { name: payload.Province[p].name, type: payload.Province[p].type, created: payload.Province[p].created, modified: payload.Province[p].modified, loc_id: payload.Province[p].loc_id };
					payload.Country[c].children.push(province);					
				}
				
			}
			for( var child in payload.Country[c].children ) {
				payload.Country[c].children[child].children = [];
				if( payload.District.length > 0 ) {
					
				} else if( payload.Town.length ) {
					for( var t in payload.Town ){
						if( payload.Town[t].parent == payload.Country[c].children[child].loc_id ) {
							var town = { name: payload.Town[t].name, type: payload.Town[t].type, created: payload.Town[t].created, modified: payload.Town[t].modified, loc_id: payload.Town[t].loc_id };
							payload.Country[c].children[child].children.push(town);							
						}					
					}
				}			
			}
		} 
		
		if( payload.Country[c].children.length == 0 && payload.District.length > 0 ) {
			
		} else if( payload.Country[c].children.length == 0 && payload.Town.length > 0 ) {
			for( var t in payload.Town ){
				console.log( 'Test' );
				if( payload.Town[t].parent == payload.Country[c].loc_id ) {
					var town = { name: payload.Town[t].name, type: payload.Town[t].type, created: payload.Town[t].created, modified: payload.Town[t].modified, loc_id: payload.Town[t].loc_id };
					//console.log( payload.Town[t].name + ' - ' + payload.Country[t].name );
					//payload.Country[c].children[child].children.push(town);							
				}					
			}			
		}
	}*/
	
	var countries = [];
	for( var k in payload ) {
		countries.push( payload[k].attr );
	}
	
	state.regionList = countries;
	//state.regionList = payload;
	//state.regionList = objFinalRegions;
}

export const setRegionParents = (state, payload) => {
	var objRegions = [];
	var currentType = '';		
	for( var k in payload ) {		
		if( payload[k].name != '' ) {
			var regionType = payload[k].type.charAt(0).toUpperCase() + payload[k].type.slice(1);	
			if( regionType != currentType ) {
				objRegions.push({ header: regionType });
				currentType = regionType;				
			}				
			payload[k].text = payload[k].name;	
			objRegions.push( payload[k] );
		}	
	}
	state.regionParents = objRegions;	
}

export const setRegionSelectors = (state, payload) => {	
	
	var objSelectors = [];
	
	for( var c in state.regionList.Country ) {
		if( state.regionList.Country[c].name !== '' ) {
			objSelectors.push({text: state.regionList.Country[c].name, id: state.regionList.Country[c].id});	
			if( state.regionList.Country[c].children ) {
				for( var p in state.regionList.Country[c].children ) {
					objSelectors.push({text: ' - ' + state.regionList.Country[c].children[p].name, id: state.regionList.Country[c].children[p].id});
					if( state.regionList.Country[c].children[p].children ) {
						for( var d in state.regionList.Country[c].children[p].children ) {
							objSelectors.push({text: ' -- ' + state.regionList.Country[c].children[p].children[d].name, id: state.regionList.Country[c].children[p].children[d].id});						
						}
					}
				}
			}
		}		
	}	
	state.regionSelectors = objSelectors;	
}

export const setRegionChildren = (state, payload) => {		
	var regionChildren = [];
	for( var k in payload ) {
		regionChildren.push( payload[k].attr );
	}
	if( payload == null ) {
		state.regionChildren = null;
	} else {
		state.regionChildren = regionChildren;	
	}	
}

export const fncFilterRegions = (state, payload) => {	
	var searchedRegions = []
	var searchFor = payload.search.toLowerCase();
	if (payload.search == '') {
		state.regionSearch = payload.regions
	} else {

		for (var k in payload.regions) {
			var name = payload.regions[k].name.toLowerCase(); 
			if (name.indexOf(searchFor) != -1) {
				searchedRegions.push(payload.regions[k]);
			}
			for (var n in payload.regions[k].children) {
				var name = payload.regions[k].children[n].name.toLowerCase();				
				if (name.indexOf(searchFor) != -1) {					
					searchedRegions.push(payload.regions[k].children[n]);
				}
				for (var x in payload.regions[k].children[n].children) {
					var name = payload.regions[k].children[n].children[x].name.toLowerCase();
					if (name.indexOf(searchFor) != -1) {
						searchedRegions.push(payload.regions[k].children[n].children[x]);
					}
					for (var y in payload.regions[k].children[n].children[x].children) {
						var name = payload.regions[k].children[n].children[x].children[y].name.toLowerCase();
						if (name.indexOf(searchFor) != -1) {
							searchedRegions.push(payload.regions[k].children[n].children[x].children[y]);
						}
					}
				}                
			}
		}
		for ( var f in searchedRegions ){
			searchedRegions[f].children = [];
		}
		state.regionSearch = searchedRegions;
	}    
}